import React from "react";
import { Button } from "@/components/ui/button";
import { AlertTriangle } from "lucide-react";

interface ErrorBoundaryProps {
  children: React.ReactNode;
}

interface ErrorBoundaryState {
  hasError: boolean;
}

class ErrorBoundary extends React.Component<ErrorBoundaryProps, ErrorBoundaryState> {
  state: ErrorBoundaryState = { hasError: false };

  static getDerivedStateFromError(): ErrorBoundaryState {
    return { hasError: true };
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    console.error("ErrorBoundary caught:", error, errorInfo);
  }

  handleRetry = () => {
    this.setState({ hasError: false });
  };

  render() {
    if (this.state.hasError) {
      return (
        <div data-nosnippet className="min-h-screen flex flex-col items-center justify-center gap-4 bg-background text-foreground p-6">
          <AlertTriangle className="h-12 w-12 text-destructive" />
          <h2 className="text-xl font-semibold">Coś poszło nie tak</h2>
          <p className="text-muted-foreground text-center max-w-md">
            Nie udało się załadować tej strony. Spróbuj odświeżyć lub wróć na stronę główną.
          </p>
          <div className="flex gap-3">
            <Button onClick={this.handleRetry} variant="outline">
              Spróbuj ponownie
            </Button>
            <Button onClick={() => window.location.assign("/")}>
              Strona główna
            </Button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
